import {createAction, props} from "@ngrx/store";
import {AuthorityDto} from "@shared/dto";

export const AUTHORITY_ACTIONS_TYPE = '@app/authority';

// Load list
export const readAuthorities = createAction(`${AUTHORITY_ACTIONS_TYPE}/read`);
export const readAuthoritiesSuccess = createAction(`${AUTHORITY_ACTIONS_TYPE}/read/success`, props<{ data: AuthorityDto[] }>());
export const readAuthoritiesFailure = createAction(`${AUTHORITY_ACTIONS_TYPE}/read/failure`, props<{ error: any }>());

// Create
// Update
// Delete
// Restore
